/**
 * 被害種別選択ダイアログ画面用モジュール。
 * @module app/signage/damagetype/DamageTypeDialog
 */
define([
	'module',
	'dojo/_base/declare',
    'dojo/_base/array',
	'dojo/_base/lang',
    'dojo/topic',
    'dojo/text!./templates/DialogContent.html',
    'dstore/Memory',
    'idis/view/page/_PageBase',
    'app/damage/consts/DamageType',
    // 以下、変数で受けないモジュール
    'idis/view/form/Button',
    'dijit/layout/BorderContainer',
    'dijit/layout/ContentPane',
    './DamageTypeGrid'
], function(module, declare, array, lang, topic, template, Memory, WidgetBase, DamageType) {

    /**
     * 被害種別選択ダイアログ
     * @class DamageTypeDialog
     * @extends module:idis/view/page/_PageBase~_PageBase
     */
    return declare(module.id.replace(/\//g, '.'), WidgetBase,
        /** @lends app/signage/damagetype/DamageTypeDialog~DamageTypeDialog# */ {

        // テンプレート文字列
        templateString: template,

        // ルート要素に付与されるCSS
        baseClass: 'damagetype-selector',

		SELECTION_RELEASED: 'app/signage/damagetype/DamageTypeSelector::released',

        /**
         * データ格納用オブジェクト
         * @type {module:dstore/Store}
         */
        store: null,

        noUnderlay: true,
        title: '被害種別選択',
        hasData: false,

        _grid: null,

        /**
         * コンストラクタ
         */
        constructor: function() {
            this.inherited(arguments);

            this.store = new Memory({
                'idProperty': 'damageTypeId',
                'data': []
            });
        },

        /**
         * DOM生成
         */
        buildRendering: function() {
            this.inherited(arguments);
        },

        /**
         * 画面生成完了
         */
        startup: function() {
            this.inherited(arguments);
            this._grid = this.grid;
            this.initContent();

            topic.subscribe(this.SELECTION_RELEASED, lang.hitch(this, function (dialog) {
                this._grid = dialog.getChildren()[0].grid;
                this.initContent();
            }));
        },

        /**
         * 画面を再表示
         */
        refresh: function() {
            this.container.resize();
            this.item = null;
        },

        /**
        * widget生成後, 画面表示前
        */
        postCreate: function () {
            this.inherited(arguments);
        },

        initContent: function() {

            var data = [];
            if(!this.hasData){
                array.forEach(Object.keys(DamageType), function(id) {
                    var obj = {};
                    var key = ('00' + String(id)).slice(-2); // iをゼロパディング
                    obj.damageTypeId = key;
                    obj.damageType = DamageType[key];
                    // 並び順をセット
                    obj.order = {
                        '01': 1,
                        '02': 2,
                        '03': 3 ,
                        '04': 4,
                        '05': 5,
                        '06': 6,
                        '07': 7,
                        '08': 8,
                        '09': 9,
                        '10': 10,
                        '14': 11,
                        '15': 12,
                        '11': 13,
                        '12': 14,
                        '13': 15
                    }[id];
                    data.push(obj);
                }, DamageType);
            }

            data.sort(function(a, b){
                return a.order - b.order;
            });

            this._grid.reset();

            array.forEach(data, lang.hitch(this, function(item) {
                this.store.addSync(item);
            }));

            this._grid.set('collection', this.store);
            this.hasData = true;
        },

        onConfirm: function() {
            this.inherited(arguments);

            this.emit('update', {
                data: {
                    mainTypeIds: this.grid.mainTypeIds
                }
            });

        },

        onCancel: function() {
            this.inherited(arguments);
            this.close();
        },

        show: function() {
            this.inherited(arguments);

            this.grid.resize();
            this.container.resize();
        },

        onHide: function() {
            this.inherited(arguments);
            this._newStore();
            this.grid.set('collection', this.store);
            this.hasData = false;
        },

        close: function() {
            this.inherited(arguments);
            this.hide();
        },

        _newStore: function () {
            if (this.store) {
                delete this.store;
            }

            this.store = new Memory({
                'idProperty': 'damageTypeId',
                'data': []
            });
        }
    });

});
